import { FC } from 'react';
import { Button, Col, Form, Input, Modal, Row, Select } from 'antd';
import { FormattedMessage } from 'react-intl';
import { RiCloseFill } from 'react-icons/ri';
import { showErrorNotification, useAssets } from '../../assets/useAssets';
import { getAssetString } from '../rents-form';
import { useRents } from '../useRents';
import { useParams } from 'react-router-dom';

export interface Props {
  open: boolean;
  handleCancel: () => void;
}

type FormModel = { asset: string; paymentValue: number };

const AddRentEquipmentModal: FC<Props> = (props) => {
  const [form] = Form.useForm();
  const { id } = useParams<{ id: string }>();
  const { addRentEquipment, rentsQuery } = useRents();
  const handleConfirm = (values: FormModel) => {
    if (!values.asset || !values.paymentValue) {
      showErrorNotification('Por favor preencha todos os campos obrigatórios');
      return;
    }
    addRentEquipment({
      rentId: id,
      dto: { asset: values.asset, paymentValue: Number(values.paymentValue) },
    });
    props.handleCancel();
    form.resetFields();
  };

  let initialValues = {};

  const { assetsQuery } = useAssets();

  const selectedRent = rentsQuery.data?.find((rent) => rent.id === id);

  const assets =
    assetsQuery.data
      ?.filter((asset) => {
        if (selectedRent) {
          return !selectedRent.rentLines.find(
            (line) =>
              String(line.asset.serialNumber) === String(asset.serialNumber),
          );
        }
        return true;
      })
      .filter((asset) => asset.state.type === 'AVAILABLE') || [];

  function handleValueWithVatChange(value: string) {
    const paymentValueWithVat = Number(value);
    const paymentValue = (100 / 123) * paymentValueWithVat;

    form.setFieldValue('paymentValue', paymentValue.toFixed(2));
  }

  function handleValueChange(value: string) {
    const paymentValueWithVat = Number(value) * 1.23;

    form.setFieldValue('paymentValueWithVat', paymentValueWithVat.toFixed(2));
  }
  return (
    <Modal
      title={<h5>Adicionar equipamento ao aluguer</h5>}
      width={416}
      open={props.open}
      onCancel={props.handleCancel}
      footer={<></>}
      closeIcon={
        <RiCloseFill
          className='remix-icon hp-text-color-black-100 hp-text-color-dark-0'
          size={24}
        />
      }
    >
      <Form
        onFinish={handleConfirm}
        form={form}
        layout='vertical'
        name='basic'
        initialValues={initialValues}
      >
        <Form.Item required label='Equipamento' name='asset'>
          <Select placeholder='Selecione o equipamento'>
            {assets.map((asset) => (
              <Select.Option value={String(asset.serialNumber)}>
                {getAssetString(asset)}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item required label='Valor s/IVA' name='paymentValue'>
          <Input
            required
            onChange={(e) => handleValueChange(e.target.value)}
            type='number'
          />
        </Form.Item>
        <Form.Item required label='Valor c/IVA' name='paymentValueWithVat'>
          <Input
            required
            onChange={(e) => handleValueWithVatChange(e.target.value)}
            type='number'
          />
        </Form.Item>
        <Row>
          <Col md={12} span={24} className='hp-pr-sm-0 hp-pr-12'>
            <Button block type='primary' htmlType='submit'>
              Adicionar
            </Button>
          </Col>

          <Col md={12} span={24} className='hp-mt-sm-12 hp-pl-sm-0 hp-pl-12'>
            <Button block onClick={props.handleCancel}>
              <FormattedMessage id='cancel' />
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
export default AddRentEquipmentModal;
